import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import Paper from 'components/Paper';
import DateInput from 'components/DateInput';

const StyledFindAccountView = styled.div`
  ${Button} {
    margin-top: ${({ theme }) => theme.spacing * 2}px;
  }

  ${Paper} {
  margin-bottom: ${({ theme }) => theme.spacing * 4}px;
  }
`;

const FindAccountView = ({ onSubmit, error }) => {
  const [dob, setDob] = useState();

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(dob);
  };

  return (
    <StyledFindAccountView>
      <h1>Welcome!</h1>
      <h1>One last thing...</h1>
      <p>Please verify your date of birth so we can correctly identify your easycare account</p>
      <Paper>
        <form onSubmit={handleSubmit}>
          <DateInput
            label="Date of birth"
            onChange={setDob}
            error={error}
          />
          <Button
            type="submit"
            disabled={!dob}
            fullWidth
          >
            Verify date of birth
          </Button>
        </form>
      </Paper>
    </StyledFindAccountView>
  );
};

FindAccountView.displayName = 'FindAccountView';

FindAccountView.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  error: PropTypes.string,
};

FindAccountView.defaultProps = {
  error: null,
};

export default FindAccountView;
